export const styles = {
    urlSpanStyle: {
        color: "#0288d1",
    },
};
